import { $gamedId, $userLanguage, $userToken } from '@/entities/user'
import { $isSteamDataLoading } from '@/entities/platforms/steam/store'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { preloadImages } from '../util/preloadImage'
import WebApp from '@twa-dev/sdk'
import { useUnit } from 'effector-react'
import { renderToStaticMarkup } from 'react-dom/server'
import { lang } from '../constants/lang'
// import { postUploadStories } from '../api'
import { postUploadStories } from '@/entities/stories/model/api'
import { useState } from 'react'
import { MainStories } from '@/features/stories/mainStories'
import DomToImage from 'dom-to-image'
import { getStoriesInfoFx } from '@/entities/stories/model/effects'

const storyText = "Grab Your Legacy and we'll pay it back "

export const usePostStory = () => {
  const isLoading = useUnit($isSteamDataLoading) //было раньше $isUpadting, который я закоментил, по логике не должно ничего сломать но мб что-то сломается))
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const [isMakingStoryLink, setIsMakingStoryLink] = useState(false)
  const texts = lang[userLang].webappPopup
  const userData = useUnit($steamUserData)
  const gamedId = useUnit($gamedId)

  const canShareStory: boolean = !isLoading && WebApp.initDataUnsafe.user!.is_premium!

  const imageUrls = [
    '/assets/backgrounds/storiesGlow1.png',
    '/assets/backgrounds/storiesGlow2.png',
    '/assets/backgrounds/gamedOpacityDecreased.webp',
    '/assets/webp/icons/gigiVector.webp',
    '/assets/webp/icons/gigi.webp',
    '/assets/webp/icons/bluePremiumStar.webp',
    '/assets/social/farcana.webp',
    '/assets/social/steam.webp',
    '/assets/social/epicgames.webp',
    '/assets/social/riotgames.webp',
    userData?.userData?.photoUrl ?? '',
  ]

  async function initStory(): Promise<string | null> {
    try {
      const storiesInfo = await getStoriesInfoFx(userToken!)

      const htmlString = renderToStaticMarkup(
        <MainStories
          info={{
            nickname: userData?.userData?.name ?? 'GAMED',
            avatar: userData?.userData?.photoUrl ?? '',
            gamedId: gamedId ?? 'GAMED',
            info: storiesInfo,
          }}
        />
      )

      const container = document.createElement('div')
      container.style.display = 'none'
      container.innerHTML = htmlString
      const uniqueId = `story-container-${Date.now()}`
      container.id = uniqueId
      document.body.appendChild(container)

      return uniqueId
    } catch (error) {
      console.error('Failed to load images:', error)
      return null
    }
  }

  const handleShareStory = async () => {
    await preloadImages(imageUrls)
    setIsMakingStoryLink(true)

    if (!WebApp.initDataUnsafe.user?.is_premium) {
      setIsMakingStoryLink(false)
      return WebApp.showPopup({
        title: texts.error,
        message: texts.needTgPremiumForStories,
      })
    }

    if (!WebApp.isVersionAtLeast('8.0')) {
      setIsMakingStoryLink(false)
      return WebApp.showPopup({
        title: texts.error,
        message: texts.tgVersionTooOldForStories,
      })
    }

    const storiesElement = await initStory()

    if (!storiesElement) {
      setIsMakingStoryLink(false)
      return WebApp.showPopup({
        title: texts.error,
        message: texts.tryAgain,
      })
    }

    const container = document.getElementById(storiesElement)!
    container.style.display = 'block'
    DomToImage.toBlob(container, {
      width: container.scrollWidth * 2,
      height: container.scrollHeight * 2,
      style: {
        transform: 'scale(2)',
        transformOrigin: 'top left',
      },
    })
      .then(async (blob) => {
        setTimeout(() => {
          container.style.display = 'none'
        }, 3000)

        if (!blob) {
          setTimeout(() => {
            setIsMakingStoryLink(false)
          }, 500)
          return WebApp.showPopup({
            title: texts.error,
            message: texts.tryAgain,
          })
        }

        const formData = new FormData()
        formData.append('image', blob, 'story.jpg')

        await postUploadStories(userToken!, formData)
          .then((res) => {
            if (!res?.file_url) {
              setIsMakingStoryLink(false)
              return WebApp.showPopup({
                title: texts.error,
                message: texts.tryAgain,
              })
            }
            WebApp.shareToStory(res.file_url, {
              text: storyText + userData?.userData?.ref_url_story,
            })
            setIsMakingStoryLink(false)
          })
          .catch(() => {
            setIsMakingStoryLink(false)
            return WebApp.showPopup({
              title: texts.error,
              message: texts.tryAgain,
            })
          })
          .finally(() => {
            document.body.removeChild(container)
            setIsMakingStoryLink(false)
          })
      })
      .catch(() => {
        setIsMakingStoryLink(false)
        return WebApp.showPopup({
          title: texts.error,
          message: texts.tryAgain,
        })
      })
  }

  return {
    canShareStory,
    isMakingStoryLink,
    handleShareStory,
  }
}
